export const EVENT_FILTER_ID = 'eventFilterId';
export const EVENT_FILTER = 'eventFilter';
export const UPDATE_TYPE = 'updateType';

/* update types */
export const CREATE = 'CREATE';
export const UPDATE = 'UPDATE';
export const DELETE = 'DELETE';